import { Button, Grid, IconButton, Menu, MenuItem } from "@biggeo/bg-ui/lab";
import { DatascapeHorizontalLogo, MenuOutline } from "@biggeo/bg-ui/lab/icons";
import { BigGeoLink } from "../common/components/BigGeoLink";
import { Routes } from "../navigation/redux/model";

enum ExternalLinks {
    docs = "https://docs.biggeo.com/reference/introduction",
    contactSales = "https://biggeo.com/deploy/contact-sales",
    joinBigGeoDiscord = "https://discord.gg/zPFRwkRNjw",
    marketplace = "https://marketplace.biggeo.com",
}

export const SignInUpHeader = () => {
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            sx={{
                background: (theme) => theme.palette.background.main,
                borderBottom: 1,
                borderColor: (theme) => theme.palette.stroke[100],
                padding: 4,
            }}
        >
            <Grid item>
                <BigGeoLink href={Routes.home}>
                    <DatascapeHorizontalLogo
                        width={26}
                        height="auto"
                        viewBox="0 0 120 20"
                    />
                </BigGeoLink>
            </Grid>
            <Grid
                item
                sx={{
                    display: "none",
                    breakpoints: {
                        md: {
                            display: "block",
                        },
                    },
                }}
            >
                <Grid container alignItems="center" gap={2}>
                    <BigGeoLink
                        variant="new-tab"
                        href={ExternalLinks.marketplace}
                    >
                        <Button variant="ghost" tabIndex={-1}>
                            Marketplace
                        </Button>
                    </BigGeoLink>
                    <BigGeoLink
                        variant="new-tab"
                        href={ExternalLinks.contactSales}
                    >
                        <Button color="primary" tabIndex={-1}>
                            Contact Sales
                            {/* Contact Support */}
                        </Button>
                    </BigGeoLink>
                </Grid>
            </Grid>
            <Grid
                item
                sx={{
                    breakpoints: {
                        md: {
                            display: "none",
                        },
                    },
                }}
            >
                <Menu
                    placement="bottom-end"
                    content={
                        <>
                            <MenuItem label="Marketplace" density="dense" />
                            <BigGeoLink
                                variant="new-tab"
                                href={ExternalLinks.contactSales}
                            >
                                <MenuItem
                                    label="Contact Sales"
                                    // label="Contact Support"
                                    density="dense"
                                />
                            </BigGeoLink>
                        </>
                    }
                >
                    <IconButton variant="outlined">
                        <MenuOutline size="xs" />
                    </IconButton>
                </Menu>
            </Grid>
        </Grid>
    );
};
